import { isSharedArrival } from "../url-routing";
import { createPersistedToggle } from "./persisted-toggle";

/** Defaults on only for a shared-schematic arrival; an explicit stored choice
 *  always wins, however the page was reached. */
export const useFuseVisibility = createPersistedToggle("twelve-volt:show-fuses", isSharedArrival);
